
import { SaleConfig } from "@/models/user-configs/sale-config";
import { getModel, Model } from "@/utils/models/model";
import { SaleConfigCalendarToShowField } from "@/utils/sale-config-calendar-to-show-field";
import Vue from "vue";
import AppSaleTypeCalendarSettingsEditItem from "./SaleTypeCalendarSettingsEditItem.vue";

export default Vue.extend({
	data(){
		return {
			toEditItem: null as null | SaleConfigCalendarToShowField
		};
	},
	props: {
		userConf: {
			type: Object as ()=>SaleConfig,
			required: true
		}
	},
	computed: {
		isNewEditItem():boolean {
			if (!this.toEditItem) return false;
			return this.userConf.CalendarToShowFields.indexOf(this.toEditItem) == -1;
		},
		model():Model{
			return getModel("Sale");
		}
	},
	methods: {
		addClicked(){
			this.toEditItem = new SaleConfigCalendarToShowField();
			this.toEditItem.Prop = "ID";
		},
		getText(conf:SaleConfigCalendarToShowField):string{
			let f = this.model.getField(conf.Prop);
			if (!f) return "ERROR";
			return f.getPropertyTranslation();
		},
		onValue(val:SaleConfigCalendarToShowField){
			if (!this.toEditItem) return;
			let i = this.userConf.CalendarToShowFields.indexOf(this.toEditItem);
			if (i == -1){
				this.userConf.CalendarToShowFields.push(val);
			}else{
				this.$set(this.userConf.CalendarToShowFields, i, val);
			}
		},
		editItem(item:SaleConfigCalendarToShowField){
			this.toEditItem = item;
		},
		removeItem(item:SaleConfigCalendarToShowField){
			let i = this.userConf.CalendarToShowFields.indexOf(item);
			if (i == -1) return;
			this.userConf.CalendarToShowFields.splice(i, 1);
		}
	},
	components: {
		AppSaleTypeCalendarSettingsEditItem
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
